import { Component, Input, inject } from '@angular/core';
import {ExternalOffer} from '../../../data/models/external-offer.model';
import {TranslationService} from '../../../core/services/translation.service';
import {NavigationService} from '../../../data/services/navigation.service';
import {MatCard, MatCardImage} from "@angular/material/card";
import {CurrencyPipe, NgClass, NgOptimizedImage} from '@angular/common';
import {MatButton} from "@angular/material/button";
import {ImageService} from '../../../core/services/image.service';

@Component({
  selector: 'app-external-offer-card',
  templateUrl: './external-offer-card.component.html',
  styleUrls: ['./external-offer-card.component.css'],
  imports: [
    MatCard,
    NgClass,
    MatCardImage,
    CurrencyPipe,
    MatButton,
    NgOptimizedImage
],
  standalone: true
})
export class ExternalOfferCardComponent {
  navigationService = inject(NavigationService);
  translationService = inject(TranslationService);
  imageService = inject(ImageService);

  @Input() externalOffer: ExternalOffer;
  @Input() showOnOfferPage: boolean = true;
}
